import "core-js/modules/es6.number.constructor";

/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { ENGINE } from '../engine';
import { NonMaxSuppressionV3 } from '../kernel_names';
import { convertToTensor } from '../tensor_util_env';
import { nonMaxSuppSanityCheck } from './nonmax_util';
import { op } from './operation';

function nonMaxSuppression_(boxes, scores, maxOutputSize) {
  var iouThreshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  var scoreThreshold = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Number.NEGATIVE_INFINITY;
  var $boxes = convertToTensor(boxes, 'boxes', 'nonMaxSuppression');
  var $scores = convertToTensor(scores, 'scores', 'nonMaxSuppression');
  var inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
  maxOutputSize = inputs.maxOutputSize;
  iouThreshold = inputs.iouThreshold;
  scoreThreshold = inputs.scoreThreshold;
  var attrs = {
    maxOutputSize: maxOutputSize,
    iouThreshold: iouThreshold,
    scoreThreshold: scoreThreshold
  };
  return ENGINE.runKernelFunc(function (b) {
    return b.nonMaxSuppression($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
  }, {
    boxes: $boxes,
    scores: $scores
  }, null
  /* grad */
  , NonMaxSuppressionV3, attrs);
}

export var nonMaxSuppression = op({
  nonMaxSuppression_: nonMaxSuppression_
});